import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Badge } from 'wix-style-react'

const ImageContainer = styled.div`
  flex: 5;
  border-top: solid 0.5px #e8e8e8;
  border-bottom: solid 0.5px #e8e8e8;
  position: relative;
  height: 1em;
`
const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
`
const BadgeContainer = styled.div`
  position: absolute;
  bottom: 10px;
  width: 100%;
`
const IPCImage = ({image, onClick, productsTagged}) => {
  return (
    <ImageContainer onClick={onClick}>
      <Image src={image} />
      <BadgeContainer>
        <Badge
          appearance='T5.1'
          type={(productsTagged > 0) ? 'success' : 'default'}
        >
          {productsTagged} product(s) tagged
        </Badge>
      </BadgeContainer>
    </ImageContainer>
  )
}

IPCImage.defaultProps = {
  productsTagged: 0,
  onClick: () => null
}

IPCImage.propTypes = {
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  productsTagged: PropTypes.number
}

export default IPCImage



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/instaPostCard/IPCImage.js